/**
 * Hard limits and shared constants for the free vs Pro plan.
 *
 * Single source of truth so feature gates stay in sync across UI surfaces.
 */
import { readGrandfatherCount } from '@/lib/favoritesMigration';

export const FREE_FAVORITE_LIMIT = 2;

/** Free-plan favorite cap including migration grandfather count (pure read). */
export function getEffectiveFavoriteLimit(): number {
  return Math.max(FREE_FAVORITE_LIMIT, readGrandfatherCount() ?? 0);
}

/** Special error code thrown by useFerryFavorites when the free limit is hit. */
export const FREE_LIMIT_ERROR = 'FREE_FAVORITE_LIMIT_REACHED';

export class FreeLimitError extends Error {
  code = FREE_LIMIT_ERROR;
  constructor(message = 'Free favorite limit reached') {
    super(message);
    this.name = 'FreeLimitError';
  }
}

export function isFreeLimitError(err: unknown): err is FreeLimitError {
  return (
    err instanceof FreeLimitError ||
    (err instanceof Error && (err as { code?: string }).code === FREE_LIMIT_ERROR)
  );
}
